import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { colors, fonts } from './variables';

import parentTheme from '../..';
const theme = createMuiTheme({
  ...parentTheme({ colors, fonts })
});

export default theme;
